import { OutlineButtonProps, PrimaryButtonProps } from "@/types/types";
import { ReactNode } from "react";
export const PrimaryButton = ({
  children,
  disabled,
  onClick,
  className,
  color,
  textColor,
}: PrimaryButtonProps) => {
  const handleClick = onClick ? onClick : () => {};
  const defaultColor = "#ffffff";
  const defaultBgColor = "#DA5700";
  return (
    <button
      type="submit"
      onClick={handleClick}
      disabled={disabled}
      style={{
        color: textColor ? textColor : defaultColor,
        backgroundColor: color ? color : defaultBgColor,
      }}
      className={`${className} text-white rounded-[8px]  font-semibold   px-4 py-3`}
    >
      {children}
    </button>
  );
};
export const Button = ({
  children,
  disabled,
  onClick,
  className,
  color,
  textColor,
}: PrimaryButtonProps) => {
  const handleClick = onClick ? onClick : () => {};
  const defaultColor = "#ffffff";
  const defaultBgColor = "#DA5700";
  return (
    <button
      type="submit"
      onClick={handleClick}
      disabled={disabled}
      style={{
        color: textColor ? textColor : defaultColor,
        backgroundColor: color ? color : defaultBgColor,
      }}
      className={`${className} text-white rounded-[8px]  font-semibold  `}
    >
      {children}
    </button>
  );
};

export const OutlineButton = ({
  children,
  disabled,
  onClick,
  className,
}: OutlineButtonProps) => {
  const handleClick = onClick ? onClick : () => {};

  return (
    <button
      type="submit"
      onClick={handleClick}
      disabled={disabled}
      className={`${className}  rounded-[8px]  font-semibold  border border-[#D0D5DD]    px-4 py-3`}
    >
      {children}
    </button>
  );
};

export type ButtonProps = {
  id?: string;
  children: ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  padding?: string;
  backgroundColor?: string;
  color?: string;
  borderRadius?: string;
  fontSize?: string;
  fontWeight?: string;
  hoverBackgroundColor?: string;
  hoverColor?: string;
  border?: string;
  className?: string;
  variant?: "default" | "outline" | "normal";
  type?: "submit" | "button" | "reset" | undefined;
};

export type IconButtonProps = {
  children: React.ReactNode;
  type?: "submit" | "button" | "reset";
  className?: string;
  disabled?: boolean;
  onClick?: () => void;
  icon?: any;
};
export const IconButton = ({
  children,
  type = "button",
  disabled,
  onClick,
  className,
  icon,
}: IconButtonProps) => {
  const handleClick = onClick ? onClick : () => {};

  return (
    <button
      onClick={handleClick}
      disabled={disabled}
      className={`${className} 
      flex justify-center gap-3 border border-[#D8D8DE] py-[10px] px-4 rounded-[8px] text-caption-1-large font-medium
      `}
      type={type}
    >
      {icon}
      {children}
    </button>
  );
};

export const CustomButton = ({
  children,
  onClick,
  padding = "10px 20px",
  backgroundColor = "#DA5700",
  color,
  borderRadius = "8px",
  fontSize = "16px",
  fontWeight = "500",
  hoverBackgroundColor,
  hoverColor,
  border,
  disabled,
  className = "",
  variant = "default",
  type,
}: ButtonProps) => {
  const handleClick = onClick ? onClick : () => {};

  // Default text color logic
  const defaultTextColor =
    variant === "outline"
      ? color || backgroundColor // use brand color for outline text if not provided
      : color || "#ffffff";

  const variantStyles = {
    default: {
      backgroundColor,
      color: defaultTextColor,
      border: border || `2px solid ${backgroundColor}`,
      hoverBackgroundColor: hoverBackgroundColor || "#b94e00",
      hoverColor: hoverColor || color,
    },
    outline: {
      backgroundColor: "#ffffff",
      color: defaultTextColor,
      border: `1px solid #D0D5DD`,
      hoverBackgroundColor: hoverBackgroundColor || backgroundColor,
      hoverColor: hoverColor || "#ffffff",
    },
    normal: {
      backgroundColor,
      color,
      border: border || "none",
      hoverBackgroundColor: hoverBackgroundColor || "#b94e00",
      hoverColor: hoverColor || color,
    },
  };

  const styles = variantStyles[variant];

  // Determine the final border style
  const finalBorderStyle = border || styles.border;

  return (
    <button
      type={type ? type : "button"}
      disabled={disabled}
      onClick={handleClick}
      style={{
        padding,
        backgroundColor: styles.backgroundColor,
        color: styles.color,
        borderRadius,
        fontSize,
        fontWeight,
        border: finalBorderStyle,
      }}
      className={`transition disabled:opacity-60 duration-200 ease-in-out whitespace-nowrap ${className}`}
    >
      {children}
    </button>
  );
};

export default Button;
